module.exports = __webpack_public_path__ + "static/media/bg-btn.d6efe11b.png";